import { invalidateReportsCache, reportsCacheKey } from '../../reports/infra/reportsRemoteCache';

export function branchSalesListReportsCachePrefix(branchId: string): string {
  return reportsCacheKey(['reports_list_branch_sales', branchId]) + '|';
}

/**
 * Prefix para el RPC by_channel (usado cuando no hay scope de Informes).
 * El cache key de fetchRemoteListSales usa el rpcName como primera parte,
 * que puede ser `reports_list_branch_sales_by_channel` o `reports_list_branch_sales`.
 */
export function branchSalesListByChannelReportsCachePrefix(branchId: string): string {
  return reportsCacheKey(['reports_list_branch_sales_by_channel', branchId]) + '|';
}

export function saleDetailReportsCacheKey(saleId: string): string {
  return reportsCacheKey(['reports_get_sale_detail', saleId]);
}

/** Invalida listados remotos de ventas de una sucursal (todas las páginas/filtros en cache). */
export function invalidateBranchSalesListCaches(branchId: string): void {
  const key = branchId.trim();
  if (!key) return;
  invalidateReportsCache(branchSalesListReportsCachePrefix(key));
  invalidateReportsCache(branchSalesListByChannelReportsCachePrefix(key));
}

export function invalidateSaleDetailCache(saleId: string): void {
  const key = saleId.trim();
  if (!key) return;
  invalidateReportsCache(saleDetailReportsCacheKey(key));
}

/** Tras mutar una venta: listado de sucursal + detalle de esa venta. */
export function invalidateSalesListCachesForSale(branchId: string, saleId: string): void {
  invalidateBranchSalesListCaches(branchId);
  invalidateSaleDetailCache(saleId);
}
